export default {
  404: "404",
  register: "रजिस्टर",
  login: "लॉगिन",
  profit: "लाभ",
  payout: "लक्ष्य भुगतान",
  btnDouble: "2×",
  wagered: "शर्त लगाई गई",
  deposit: "जमा",
  inputFieldBtnMax: "अधिकतम",
  bets: "दांव",
  topHeaderAmount: "राशि",
  resetPasswordTitle: "पासवर्ड रीसेट करें",
  resetPasswordNewPasswordTitle: "नया पासवर्ड",
  resetPasswordNewPasswordErrorsRequired: "पासवर्ड आवश्यक है।",
  resetPasswordNewPasswordErrorsMinLength: "कम से कम 8 अक्षर होने चाहिए।",
  resetPasswordNewPasswordErrorsMaxLength: "अधिकतम 16 अक्षर होने चाहिए।",
  resetPasswordNewPasswordErrorsPattern:
    "8-16 अक्षर होने चाहिए, जिसमें बड़े और छोटे अक्षर, संख्याएँ और एक विशेष चिन्ह होना चाहिए (जैसे, NextGen@123)",
  resetPasswordConfirmPasswordTitle: "पासवर्ड की पुष्टि करें",
  resetPasswordConfirmPasswordErrorsNotMatched: "पासवर्ड मेल नहीं खा रहे हैं।",
  resetPasswordResetBtn: "रीसेट",
  passwordResetSuccess: "पासवर्ड बदल दिया गया",
  resetPasswordWentWrong: "कुछ गलत हो गया!",
  partners: "साझेदार",
  submit: "सबमिट",
  signinUsername: "ईमेल / उपयोगकर्ता नाम",
  signinForgetPassword: "पासवर्ड भूल गए?",
  signinErrorsUserNameRequired: "कृपया उपयोगकर्ता नाम/ईमेल दर्ज करें।",
  signinErrorsPasswordRequired: "पासवर्ड आवश्यक है।",
  signinErrorsPasswordMinLength: "कम से कम 8 अक्षर होने चाहिए।",
  signinErrorsPasswordMaxLength: "अधिकतम 16 अक्षर होने चाहिए।",
  signinTryAgain: "कुछ गलत हो गया!, कृपया पुनः प्रयास करें।",
  signinResetPasswordUsernameErr:
    "पासवर्ड रीसेट करने के लिए कृपया उपयोगकर्ता नाम/ईमेल दर्ज करें।",
  signinResetMailSentSuccessContent:
    "हमने आपके ईमेल पर पासवर्ड रीसेट लिंक भेजा है। कृपया अपना ईमेल देखें और पासवर्ड रीसेट करें।",
  signupTitle: "रजिस्टर",
  signupUsername: "उपयोगकर्ता नाम",
  signupEmail: "ईमेल",
  signupWalletConnect: "वॉलेट से लॉगिन करें",
  signupPassword: "पासवर्ड",
  signupErrorsUserNameRequired: "कृपया उपयोगकर्ता नाम दर्ज करें।",
  signupErrorsFirstNameRequired: "कृपया पहला नाम दर्ज करें।",
  signupErrorsLastNameRequired: "कृपया अंतिम नाम दर्ज करें।",
  signupErrorsUserNameMinLength:
    "कम से कम {{minimumCharacters}} अक्षर होने चाहिए।",
  signupErrorsUserNameMaxLength:
    "अधिकतम {{maximumCharacters}} अक्षर होने चाहिए।",
  signupErrorsUserNamePattern: "कृपया केवल अक्षर और संख्याएँ दर्ज करें।",
  signupErrorsStringPattern: "कृपया केवल अक्षर दर्ज करें।",
  signupErrorsEmailRequired: "कृपया ईमेल दर्ज करें।",
  signupErrorsEmailPattern: "कृपया मान्य ईमेल दर्ज करें।",
  signupErrorsPasswordRequired: "पासवर्ड आवश्यक है।",
  signupErrorsPasswordMinLength: "कम से कम 8 अक्षर होने चाहिए।",
  signupErrorsPasswordMaxLength: "अधिकतम 16 अक्षर होने चाहिए।",
  signupErrorsPasswordPattern:
    "8-16 अक्षर होने चाहिए, जिसमें बड़े और छोटे अक्षर, संख्याएँ और एक विशेष चिन्ह होना चाहिए (जैसे, NextGen@123)",
  otpIsRequired: "ओटीपी आवश्यक है",
  otpMustBeSixDigits: "ओटीपी 6 अंकों का होना चाहिए",
  enterOtp: "ओटीपी दर्ज करें",
  accountMenuTransactions: "लेन-देन",
  accountMenuPromotions: "प्रमोशन",
  accountMenuProfile: "प्रोफ़ाइल",
  accountMenuLogout: "लॉगआउट",
  accountMenuWithdraw: "निकासी",
  pageNotFound: "हम वह पृष्ठ नहीं ढूँढ पा रहे हैं जिसकी आप तलाश कर रहे हैं!",
  error: "त्रुटि",
  somethingWentWrong: "कुछ गलत हो गया!",
  verifyEmailThankYou: "धन्यवाद!",
  verifyEmailEmailIsVerified: "आपका ईमेल सत्यापित हो गया है।",
  verifyEmailWentWrong: "कुछ गलत हो गया!",
  verifyEmailTokenExpired:
    "ईमेल पहले ही सत्यापित हो चुका है या लिंक की समय सीमा समाप्त हो गई है",
  create: "बनाएँ",
  profilePassword: "पासवर्ड",
  profileUploadProfile: "फ़ोटो अपलोड करें",
  profileErrorsEmailRequired: "ईमेल आवश्यक है।",
  profileErrorsEmailPattern: "कृपया मान्य ईमेल दर्ज करें।",
  profileErrorsEmailMinLength: "कम से कम 3 अक्षर होने चाहिए।",
  profileErrorsEmailMaxLength: "अधिकतम 20 अक्षर होने चाहिए।",
  profileMessagesProfileUpdate: "प्रोफ़ाइल अपडेट हो गई",
  profileMessagesChangePassword: "पासवर्ड अपडेट हो गया",
  profileProfilePicProfilePicUpload: "प्रोफ़ाइल छवि अपलोड करें",
  profileNoNewChanges: "प्रोफ़ाइल अपडेट नहीं हो सकी! कोई नया बदलाव नहीं।",
  profileLoggedInWithSocial: "आपने सोशल लॉगिन से लॉगिन किया है।",
  profileSideNavigatorSound: "ध्वनि",
  profileSideNavigatorMusic: "संगीत",
  profileSideNavigatorProfile: "मेरी प्रोफ़ाइल",
  profileSideNavigatorBetHistory: "दांव का इतिहास",
  profileSideNavigatorTransactions: "लेन-देन",
  profileSideNavigatorDeposit: "जमा",
  withdraw: "निकासी",
  profileSideNavigatorGameLimits: "खेल सीमा",
  profileSideNavigatorReferral: "रेफ़रल",
  profileSideNavigatorChangePassword: "पासवर्ड बदलें",
  profileSideNavigatorTermsConditions: "नियम और शर्तें",
  profileSideNavigatorLogOut: "लॉग आउट",
  profileSideNavigatorProvablyFair: "साबित रूप से निष्पक्ष",
  WalletInfoSectionNotAvailable: "उपलब्ध नहीं",
  WalletInfoSectionRealBalance: "वास्तविक शेष",
  GameLimitsMinimumBet: "न्यूनतम दांव",
  GameLimitsMaximumBet: "अधिकतम दांव",
  GameLimitsMaxWinFor1Bet: "एक दांव के लिए अधिकतम जीत",
  ProvablyFairSubTitle:
    "यह खेल परिणाम निर्धारित करने के लिए Provably Fair तकनीक का उपयोग करता है। यह टूल आपको अपना सीड बदलने और खेल की निष्पक्षता जांचने की सुविधा देता है।",
  ProvablyFairMaximumBet: "अधिकतम दांव:",
  ProvablyFairMaxWinFor1Bet: "एक दांव के लिए अधिकतम जीत",
  promotionsTitle: "प्रमोशन",
  promotionsNoLosingData: "क्षमा करें, कोई हार बोनस प्रमोशन उपलब्ध नहीं है ",
  promotionsNoDepositData: "क्षमा करें, कोई जमा बोनस प्रमोशन उपलब्ध नहीं है ",
  promotionsCurrency: " मुद्रा।",
  promotionsViewBtn: "देखें",
  promotionsClaimSuccess: "आपने सफलतापूर्वक दावा किया है",
  promotionsAvailability: "उपलब्धता: ",
  promotionsAvailabilityTabLosing: "हार बोनस",
  promotionsAvailabilityTabDeposit: "जमा बोनस",
  promotionsDepositBonusTableCode: "कोड",
  promotionsDepositBonusTableMinDeposit: "न्यूनतम जमा",
  promotionsDepositBonusTablePercentage: "प्रतिशत",
  promotionsDepositBonusTableMaxBonus: "अधिकतम बोनस",
  promotionsDepositBonusTableRolloverMultipler: "रोलओवर गुणक",
  promotionsDepositBonusTableMaxRolloverPerBet: "प्रति दांव अधिकतम रोलओवर",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "रोलओवर लक्ष्य हासिल करने का समय",
  promotionsBonusCode: "बोनस कोड: ",
  promotionsLossesClaim: "हानि का दावा किया जा सकता है (अभियान अवधि के भीतर): ",
  promotionsLossesClaimLosingBonusTablePercentage: "प्रतिशत",
  promotionsLossesClaimLosingBonusTableMinLosingAmount: "न्यूनतम हानि राशि",
  promotionsBonusStatus: "बोनस स्थिति: ",
  promotionsBonusAmount: "बोनस राशि: ",
  promotionsRolloverTarget: "रोलओवर लक्ष्य: ",
  promotionsRolloverAchieved: "रोलओवर पूरा हुआ: ",
  promotionsActivatebtn: "सक्रिय करें",
  promotionsClaimBtn: "दावा करें",
  promotionsCancelBtn: "रद्द करें",
  promotionsBackBtn: "वापस",
  promotionsBonus: "बोनस",
  promotionsTermAndConditions: " नियम और शर्तें",
  promotionsClaimDepositBonusTitle: "जमा बोनस का दावा करने के चरण",
  promotionsClaimDepositBonusFirst: "बोनस कोड सक्रिय करें",
  promotionsClaimDepositBonusSecond: "वॉलेट में राशि जमा करें",
  promotionsClaimDepositBonusThird:
    "बोनस का दावा करने के लिए रोलओवर लक्ष्य पूरा करें",
  promotionsClaimLosingBonusTitle: "हार बोनस का दावा करने के चरण",
  promotionsClaimLosingBonusFirst: "बोनस कोड सक्रिय करें",
  promotionsClaimLosingBonusSecond: "अपना पसंदीदा खेल खेलें",
  promotionsClaimLosingBonusThird:
    "अभियान अवधि के भीतर हानि का दावा करने के लिए 'हानि का दावा करें' पर क्लिक करें",
  promotionsWentWrong: "कुछ गलत हो गया!",
  transactionTitle: "लेन-देन",
  transactionBetId: "दांव आईडी",
  transactionUser: "उपयोगकर्ता",
  transactionPayout: "भुगतान",
  transactionAmount: "राशि",
  transactionTime: "तारीख",
  transactionProfit: "लाभ",
  transactionCashout: "नकदी निकासी",
  transactionBet: "दांव",
  transactionMultix: "मल्टी.x",
  transactionWin: "जीत",
  transactionFairness: "निष्पक्षता",
  transactionReferFriend: "मित्र को आमंत्रित करें",
  transactionTotal: "कुल दांव",
  transactionWins: "जीत",
  transactionRefresh: "रिफ्रेश",
  transactionFilterTopMultipliers: "शीर्ष गुणक",
  transactionFilterHugeWins: "बड़ी जीत",
  transactionFilterBiggestWins: "सबसे बड़ी जीत",
  transactionFilterMultipliers: "गुणक",
  transactionRealBalance: "वास्तविक शेष",
  depositWithdrawTXDate: "तारीख",
  depositWithdrawTXAmount: "राशि",
  depositWithdrawTXTxId: "TxID",
  depositWithdrawTXTxType: "लेन-देन का प्रकार",
  depositWithdrawTXStatus: "स्थिति",
  depositWithdrawTXNoData: "कोई डेटा उपलब्ध नहीं है।",
  depositTitle: "जमा",
  depositHistory: "इतिहास",
  depositSubTitle:
    "उपयोगकर्ता फ़िएट मुद्रा जमा या निकासी नहीं कर सकता। कृपया फ़िएट मुद्रा में लेन-देन के लिए एडमिन से संपर्क करें।",
  depositCopyNotSupported:
    "आपका ब्राउज़र स्वचालित कॉपी टू क्लिपबोर्ड का समर्थन नहीं करता है।\nकृपया कोड को मैन्युअली कॉपी करने का प्रयास करें।",
  depositCopied: "पता कॉपी किया गया।",
  withdrawNoBalance: "पर्याप्त शेष नहीं है।",
  withdrawMinAmount: "कृपया {{min}} या उससे अधिक की राशि दर्ज करें।",
  paginationNextBtn: "अगला",
  paginationPrevBtn: "पिछला",
  LoginRequired: "लॉगिन आवश्यक है!",
  betPlacedSuccessfully: "दांव लगाया गया",
  betCancelledSuccessfully: "दांव सफलतापूर्वक रद्द किया गया",
  PlayerEscapedSuccessfully: "खिलाड़ी बाहर निकला",
  CopiedSuccessfull: "सफलतापूर्वक कॉपी किया गया",
  usersConsent:
    "इस साइट का उपयोग करके, मैं पुष्टि करता हूँ कि मेरी आयु 18 वर्ष है, और मैंने समीक्षा की है, \n समझा है और सहमति दी है",
  termsOfService: "सेवा की शर्तें",
  email: "ईमेल",
  playNow: "अभी खेलें",
  orContinueWith: "या इसके साथ जारी रखें",
  metamaskExtensionNotAvailable:
    "कृपया MetaMask एक्सटेंशन इंस्टॉल करें और पेज को रिफ्रेश करें।",
  cashier: "जमा करें",
  account: "खाता",
  hello: "नमस्ते",
  balance: "बैलेंस",
  referrals: "रेफ़रल्स",
  settings: "सेटिंग्स",
  withdrawals: "निकासी",
  demoWallet: "डेमो वॉलेट",
  wallet: "वॉलेट",
  user: "उपयोगकर्ता",
  amountIsRequired: "राशि आवश्यक है",
  minDepositAmount: "जमा राशि {{min}} से अधिक होनी चाहिए।",
  maxDepositAmount: "जमा राशि {{max}} से कम होनी चाहिए।",
  minWithdrawAmount: "राशि {{min}} से अधिक होनी चाहिए",
  withdrawMustLessThanWallet: "निकासी राशि आपके वॉलेट बैलेंस से कम होनी चाहिए",
  accountTypeIsRequired: "खाते का प्रकार आवश्यक है।",
  mobileNumberLength: "मोबाइल नंबर {{length}} अंकों का होना चाहिए",
  phoneIsRequired: "फोन आवश्यक है",
  cpfError: "CPF {{length}} अक्षरों का होना चाहिए",
  cpfRequiredError: "CPF आवश्यक है",
  cnpjError: "CNPJ {{length}} अक्षरों का होना चाहिए",
  mainMenu: "मुख्य मेनू",
  casino: "कसीनो",
  sports: "खेल",
  crypto: "क्रिप्टो",
  NextGenXp: "नेक्स्टजेन XP",
  playEarn: "खेलें और कमाएँ",
  NFT: "NFT",
  poker: "पोकर",
  earnRewards: "इनाम कमाएँ",
  rankUp: "रैंक बढ़ाएँ",
  inviteFriends: "दोस्तों को आमंत्रित करें",
  affiliates: "सहयोगी",
  sportsbook: "स्पोर्ट्सबुक",
  menu: "मेनू",
  allBets: "सभी शर्तें",
  highRollers: "उच्च दांव",
  luckyBets: "भाग्यशाली शर्तें",
  trade: "ट्रेड",
  player: "खिलाड़ी",
  time: "समय",
  wager: "दांव",
  payoutText: "भुगतान",
  bannerHeadOne: "सच्चे नवाचार का अनुभव करें",
  bannerHeadTwo: "उद्योग में सबसे बड़े इनाम कार्यक्रम के साथ।",
  registerNow: "अभी रजिस्टर करें",
  copy: "कॉपी करें",
  liveWins: "लाइव जीत",
  monthlyStatus: "माह",
  weeklyStatus: "सप्ताह",
  dailyStatus: "दिन",
  nextEcosystem: "नेक्स्टजेन इकोसिस्टम",
  allGames: "सभी खेल",
  allSports: "सभी खेल",
  cryptoFutures: "क्रिप्टो फ्यूचर्स",
  tradeNow: "अभी ट्रेड करें",
  allTables: "सभी टेबल",
  nft: "NFT",
  viewAll: "सभी देखें",
  rewards: "इनाम",
  profile: "प्रोफ़ाइल",
  nextgenProfile: "नेक्स्टजेन प्रोफ़ाइल",
  totalBets: "कुल शर्तें",
  totalWagered: "कुल दांव",
  joinDate: "जुड़ने की तिथि",
  displaySocialLinks: "लिंक्ड सोशल अकाउंट दिखाएँ",
  privateProfile: "निजी प्रोफ़ाइल",
  rank: "रैंक",
  nextRank: "अगला रैंक",
  changeUsername: "यूज़रनेम बदलें",
  newPassword: "नया पासवर्ड",
  repeatNewPassword: "नया पासवर्ड दोहराएँ",
  changeName: "नाम बदलें",
  linkSocialAccount: "सोशल अकाउंट लिंक करें",
  privateProfileTooltip:
    "प्रोफ़ाइल को निजी करने पर अन्य उपयोगकर्ता आपके दांव, इनाम या सोशल लिंक नहीं देख पाएंगे",
  socialLinksTooltip:
    "अन्य उपयोगकर्ताओं को आपको फॉलो करने देने के लिए अपने सोशल अकाउंट लिंक करें।",
  balances: "बैलेंस",
  createReferralBalance: "रेफ़रल बैलेंस बनाएँ",
  total: "कुल",
  tips: "सुझाव",
  receivedAmount: "प्राप्त राशि",
  dateOrTime: "तारीख/समय",
  view: "देखें",
  allChains: "सभी चैन",
  creditAmount: "क्रेडिट राशि",
  setCustomReferralLink: "कस्टम रेफ़रल लिंक सेट करें",
  changeEmail: "ईमेल बदलें",
  newEmail: "नया ईमेल",
  newUsername: "नया यूज़रनेम",
  username: "यूज़रनेम",
  changePassword: "पासवर्ड बदलें",
  twoFactorAuthentication: "दो-स्तरीय प्रमाणीकरण",
  twoFactorAuthenticationTitle:
    "दो-स्तरीय प्रमाणीकरण का उपयोग करना अत्यधिक अनुशंसित है क्योंकि यह आपके खाते को आपके पासवर्ड और आपके फोन दोनों से सुरक्षित करता है। 2FA को सक्रिय करने के लिए एक ईमेल और पासवर्ड सेट होना आवश्यक है। जब तक 2FA सक्रिय है, आप स्टीम के माध्यम से लॉगिन नहीं कर पाएंगे।",
  enable2fa: "2FA सक्षम करें",
  verifyIdentityByKyc: "अपनी पहचान सत्यापित करें (KYC)",
  oldPassword: "पुराना पासवर्ड",
  live: "लाइव",
  soccer: "फ़ुटबॉल",
  tennis: "टेनिस",
  fifa: "फ़ीफ़ा",
  basketball: "बास्केटबॉल",
  iceHockey: "आइस हॉकी",
  volleyball: "वॉलीबॉल",
  tableTennis: "टेबल टेनिस",
  baseball: "बेसबॉल",
  golf: "गॉल्फ़",
  boxing: "मुक्केबाज़ी",
  myBets: "मेरी शर्तें",
  favourites: "पसंदीदा",
  americanFootball: "अमेरिकन फ़ुटबॉल",
  buyCrypto: "क्रिप्टो खरीदें",
  oldEmail: "पुराना ईमेल",
  loggedInSuccess: "लॉगिन सफल",
  loggedOutSuccess: "लॉगआउट सफल",
  signup: "पंजीकरण पूर्ण",
  tokenVerify: "सत्यापन टोकन आपके ईमेल पर भेजा गया है। कृपया सत्यापित करें",
  emailVerify: "ईमेल सत्यापित",
  emailChangedSuccess: "ईमेल अपडेट किया गया",
  emailUpdateOtp: "नए ईमेल पर OTP भेजा गया",
  profileUpdatedSuccess: "प्रोफ़ाइल अपडेट की गई",
  otpVerified: "वन-टाइम पासवर्ड (OTP) सत्यापित",
  twoFADeactivated: "दो-स्तरीय प्रमाणीकरण निष्क्रिय",
  internalServerError: "आंतरिक सर्वर त्रुटि",
  unAuthorized: "अनधिकृत",
  dataNotFound: "डेटा नहीं मिला",
  setReferralLink: "रेफ़रल लिंक सेट करें...",
  notFound: "नहीं मिला",
  nextgenOriginals: "नेक्स्टजेन ओरिजिनल्स",
  status: "स्थिति",
  success: "सफल",
  failed: "असफल",
  pending: "लंबित",
  date: "तारीख",
  to: "तक",
  roundId: "राउंड आईडी",
  bet: "शर्त",
  win: "जीत",
  at: "पर",
  downloadAll: "सभी डाउनलोड करें",
  gameText: "खेल",
  searchGames: "खेल खोजें",
  provider: "प्रदाता",
  search: "खोजें",
  all: "सभी",
  sortBy: "क्रमबद्ध करें",
  popular: "लोकप्रिय",
  loadMore: "और लोड करें",
  bitcoin: "बिटकॉइन",
  btc: "BTC",
  chat: "चैट",
  loginToChat: "चैट करने के लिए लॉगिन करें",
  send: "भेजें",
  expand: "विस्तार करें",
  collapse: "संकुचित करें",
  emailPlaceholder: "आपकाअमेल@डोमेन.कॉम",
  removeFromFavourite: "पसंदीदा से हटाएँ",
  addToFavourite: "पसंदीदा में जोड़ें",
  verify: "सत्यापित करें",
  accountVerification: "खाता सत्यापन",
  recentlyPlayed: "हाल ही में खेला गया",
  moreFrom: "और देखें",
  demoMode: "डेमो मोड",
  providersList: "प्रदाता सूची",
  games: "खेल",
  providers: "प्रदाता",
  close: "बंद करें",
  joinedOn: "शामिल होने की तिथि",
  rewarded: "पुरस्कृत",
  saySomething: "कुछ कहें",
  addressIsRequired: "पता आवश्यक है",
  withdrawRequestSent: "निकासी अनुरोध सबमिट किया गया। स्वीकृति की प्रतीक्षा।",
  noMatchesFound: "कोई मेल नहीं मिला",
  tip: "टिप",
  sendTip: "टिप भेजें",
  minAmount: "राशि {{min}} से अधिक होनी चाहिए",
  maxAmount: "राशि {{max}} से कम होनी चाहिए",
  doNotShowTip: "चैट में टिप न दिखाएँ",
  demoAvailable: "डेमो उपलब्ध",
  denoNotAvailable: "डेमो उपलब्ध नहीं",
  goFullscreen: "पूर्ण स्क्रीन पर जाएँ",
  endsAt: "समाप्त होता है",
  inProgress: "चालू है",
  eventEnd: "कार्यक्रम समाप्त",
  latestPromotions: "नवीनतम प्रमोशन",
  archived: "संग्रहीत",
  noPromotionsFound: "कोई प्रमोशन नहीं मिला",
  claim: "दावा करें",
  add: "जोड़ें",
  viewDashboard: "डैशबोर्ड देखें",
  prize: "पुरस्कार",
  timeLeft: "शेष समय",
  viewTransactions: "लेन-देन देखें",
  sendAmountInCashier:
    "अपनी पसंद की {{- currency}} राशि नीचे दिए गए पते पर भेजें ताकि आपको बराबर के कॉइन्स मिल सकें।",
  yourPersonalDepositAddress: "आपका व्यक्तिगत {{- currency}} जमा पता",
  copyAddress: "पता कॉपी करें",
  theValueOfCurrencyMayChange:
    "{{- currency}} का मूल्य अभी और भुगतान प्राप्त होने के समय के बीच बदल सकता है",
  doNotHaveAnyCurrency: "कोई {{- currency}} नहीं है?",
  depositOptions: "जमा विकल्प",
  withdrawalOptions: "निकासी विकल्प",
  withdrawCurrency: "{{- currency}} निकालें",
  enterAddressToReceiveFunds:
    "कृपया वह {{- currency}} वॉलेट पता दर्ज करें जिस पर आप धनराशि प्राप्त करना चाहते हैं। पुष्टि के बाद, निकासी आमतौर पर कुछ मिनटों में संसाधित हो जाती है।",
  receivingCurrencyAddress: "प्राप्त करने वाला {{- currency}} पता",
  withdrawalAmount: "निकासी राशि",
  pasteYourCurrencyAddressHere: "अपना {{- currency}} वॉलेट पता यहाँ चिपकाएँ...",
  request: "अनुरोध",
  receiveTheSpecifiedAmount:
    "*आपको निर्दिष्ट {{- currency}} राशि आपके निकासी पते पर प्राप्त होगी",
  valueMayVary:
    "*आपकी शेष राशि से घटाई गई राशि अभी और निकासी संसाधन के समय के बीच बदल सकती है",
  coupons: "कूपन",
  updateEmail: "ईमेल अपडेट करें",
  update: "अपडेट करें",
  loginHistory: "लॉगिन इतिहास",
  showLoginHistory: "लॉगिन इतिहास दिखाएँ",
  wagerErr: "शर्त राशि आवश्यक है",
  minWagerErr: "न्यूनतम शर्त राशि 1 है",
  mulValErr: "गुणक मान 1 - 1000 के बीच होना चाहिए",
  closeBetErr: "मान्य क्लोज बेट राशि दर्ज करें",
  profitErr: "मान्य टेक प्रॉफिट राशि दर्ज करें",
  multiplierErr: "गुणक राशि आवश्यक है",
  manual: "मैनुअल",
  auto: "ऑटो",
  pnLFee: "PnL शुल्क",
  flatFee: "फ्लैट शुल्क",
  takeProfitLabel: "लाभ इस मूल्य पर लें",
  closeBetLabel: "बेट इस मूल्य पर बंद करें",
  priceUpLabel: "क्या कीमत ऊपर जाएगी या नीचे?",
  up: "ऊपर",
  down: "नीचे",
  payoutMul: "भुगतान गुणक",
  safe: "सुरक्षित",
  wild: "जोखिमपूर्ण",
  placeBet: "शर्त लगाएँ",
  roundEnd: "राउंड समाप्त होता है",
  timerInfo:
    "सभी रोलरकोस्टर बेट्स बंद हो जाएँगी और मूल्य प्रत्येक दिन 00:00 UTC पर $1,000 पर रीसेट हो जाएगा",
  month: "महीना",
  PNL: "PnL",
  ROI: "ROI",
  roi: "आरओआई",
  funding: "फंडिंग/घंटा",
  exitPriceLabel: "निकासी मूल्य",
  cashedOut: "नकद निकाला गया",
  open: "खुला",
  chartPreferences: "चार्ट प्राथमिकताएँ",
  yAxis: "Y-अक्ष प्राथमिकताएँ",
  additionalFeatures: "अतिरिक्त सुविधाएँ",
  themes: "थीम्स",
  locale: "स्थानीय भाषा",
  changeTimezone: "समय क्षेत्र बदलें",
  changeLanguage: "भाषा बदलें",
  tooltip: "टूलटिप",
  field: "फ़ील्ड",
  value: "मूल्य",
  dateTime: "तारीख/समय",
  winningAmount: "जीत की राशि",
  activeBets: "सक्रिय शर्तें",
  closedBets: "बंद शर्तें",
  publicBets: "सार्वजनिक शर्तें",
  leaderboard: "लीडरबोर्ड",
  howToPlay: "कैसे खेलें",
  rOICalculator: "ROI कैलकुलेटर",
  allInstruments: "सभी साधन",
  week: "सप्ताह",
  monthLabel: "महीना",
  day: "दिन",
  betLabel: "शर्त",
  entryPrice: "प्रवेश मूल्य",
  bustPriceLabel: "बस्ट मूल्य",
  multiplierLabel: "गुणक",
  exitPrice: "निकासी मूल्य",
  pnl: "लाभ/हानि",
  details: "विवरण देखें",
  profitLoss: "लाभ और हानि",
  noBalance: "पर्याप्त शेष राशि नहीं।",
  maxBetAmount: "अधिकतम शर्त राशि",
  limit: "सीमा पार हो गई।",
  minBetAmount: "न्यूनतम शर्त राशि",
  rollsLimitMsg: "रोल की संख्या 100 से कम या बराबर होनी चाहिए।",
  mines: "माइंस",
  loginFailed: "लॉगिन विफल",
  noEntries: "कोई प्रविष्टियाँ नहीं",
  descriptionIsRequired: "विवरण आवश्यक है",
  description: "विवरण",
  report: "रिपोर्ट",
  userReportedSuccessfully: "उपयोगकर्ता रिपोर्ट किया गया",
  tipSendSuccessfully: "टिप भेजी गई",
  walletSettings: "वॉलेट सेटिंग्स",
  hideZero: "शून्य शेष छुपाएँ",
  hideZeroInfo: "आपका शून्य शेष आपके वॉलेट में नहीं दिखाई देगा",
  displayFiat: "क्रिप्टो को फिएट में दिखाएँ",
  displayFiatInfo: "सभी शर्तें और लेन-देन क्रिप्टो के बराबर में निपटाए जाएँगे",
  noteForApprox: "कृपया ध्यान दें कि ये मुद्रा के अनुमान हैं।",
  save: "सहेजें",
  limits: "सीमाएँ",
  wagerLimit: "शर्त सीमा",
  lossLimit: "हानि सीमा",
  depositLimit: "जमा सीमा",
  takeABreak: "ब्रेक लें",
  customTimePeriod: "कस्टम समय अवधि",
  timePeriod: "समय अवधि",
  selfExclusion: "स्वयं बहिष्कार",
  confirm: "पुष्टि करें",
  setLimit: "सीमा तय करें",
  removeLimit: "सीमा हटाएं",
  enterAmount: "राशि दर्ज करें",
  hours: "घंटे",
  daily: "दैनिक",
  weekly: "साप्ताहिक",
  monthly: "मासिक",
  cancel: "रद्द करें",
  usedLimit: "प्रयुक्त सीमा",
  type: "प्रकार",
  updatedAt: "अद्यतन समय",
  editLimit: "सीमा संपादित करें",
  limitRemovedMessage: "आपकी निम्नलिखित सीमा हटा दी जाएगी।",
  setLimitMessage:
    "आप अपने खाते पर निम्नलिखित सीमा सेट करने जा रहे हैं। कृपया ध्यान दें कि यदि आप सीमा बदलना चाहते हैं, तो आप ऐसा 24 घंटे बाद कर सकते हैं।",
  setBreakMessage:
    "आप एक पूर्व निर्धारित अवधि के लिए अपने खाते की पहुँच को ब्लॉक करने जा रहे हैं। कृपया जान लें कि इस विकल्प का उपयोग करने के बाद आप अपने खाते में लॉगिन करके ब्लॉक अवधि को बदल नहीं पाएंगे। यदि आप अलग ब्लॉक अवधि चुनना या मौजूदा अवधि बढ़ाना चाहते हैं, तो कृपया लाइव सपोर्ट से संपर्क करें।",
  setSessionLimitMessage:
    "आप अपने खाते पर निम्नलिखित सीमा सेट करने जा रहे हैं। कृपया ध्यान दें कि यदि आप सीमा बदलना चाहते हैं, तो नई सीमा सेट करने के 24 घंटे बाद ही यह बदलेगी।",
  removeSessionLimitMessage: "आपकी सत्र सीमा हटा दी जाएगी",
  notAchieved: "प्राप्त नहीं हुआ",
  flexibleRegistration: "लचीला पंजीकरण!",
  mostPlayed: "सबसे ज्यादा खेले गए",
  badge: "बैज",
  allBadges: "सभी बैज",
  socialMedia: "सोशल मीडिया",
  allLinks: "सभी लिंक",
  statistics: "सांख्यिकी",
  newMessage: "नया संदेश",
  tipFor: "के लिए टिप",
  play: "खेलें",
  betOn: "शर्त लगाएँ",
  liveCasino: "लाइव कैसीनो",
  ecosystemUnbeatableOdds:
    "बेहतर शर्त लगाएँ - हमारे शीर्ष-स्तरीय बेटिंग प्लेटफ़ॉर्म के साथ रोमांचक आयोजनों पर अपराजेय ऑड्स पाएं!",
  startBetting: "बेटिंग शुरू करें",
  ecosystemJoinTheFun:
    "मज़ा लीजिए - NextGen के एक्सक्लूसिव गेम्स और 9,000+ कैसीनो पसंदीदा खेलों का आनंद लें!",
  futures: "फ्यूचर्स",
  ecosystemTrade:
    "NGB आपका विश्वसनीय गेटवे है भविष्य के इमर्सिव ऑनलाइन गेमिंग और बेटिंग प्लेटफ़ॉर्म की ओर!",
  ecosystemCasino24x7:
    "किसी भी समय, कहीं भी पेशेवर डीलरों के साथ रीयल-टाइम गेमिंग का रोमांच अनुभव करें। बिना रुके एक्शन में डूब जाएँ!",
  joinNow: "अभी जुड़ें",
  noNotificationsFound: "कोई सूचनाएँ नहीं मिलीं",
  notifications: "सूचनाएँ",
  lobby: "लॉबी",
  rollercoaster: "NextGen कोस्टर",
  applyReferralCode: "रेफ़रल कोड लागू करें",
  referralCode: "रेफ़रल कोड",
  referralLink: "रेफ़रल लिंक",
  copyLink: "लिंक कॉपी करें",
  referralLinkCopied: "रेफ़रल लिंक कॉपी किया गया",
  withdrawAddressCannotBeSame: "निकासी पता आपके अपने पते के समान नहीं हो सकता",
  userId: "यूज़र आईडी",
  active: "सक्रिय",
  inactive: "निष्क्रिय",
  currency: "मुद्रा",
  hostGames: "गेम्स होस्ट करें",
  earnCrypto: "क्रिप्टो कमाएँ",
  inviteHostAndEarn:
    "आमंत्रित करें, होस्ट करें और कमाएँ - अपने खुद के NextGen इवेंट्स चलाएँ",
  startEarning: "कमाना शुरू करें",
  nextGen: "NextGen",
  whitePaper: "श्वेतपत्र",
  deepDiveInto: "NextGen कॉइन अर्थव्यवस्था में गहराई से डुबकी लगाएँ",
  learnMore: "अधिक जानें",
  sport: "खेल",
  vipRanked: "वीआईपी रैंक्ड",
  betMoreEarnMore: "अधिक शर्त लगाएँ, अधिक कमाएँ - अपनी क्षमता को अधिकतम करें",
  expiresAt: "समाप्ति तिथि",
  upload: "अपलोड करें",
  pleaseSelectImage: "कृपया छवि चुनें",
  imageSizeMustLessThan: "छवि का आकार {{size}} MB से कम होना चाहिए",
  imageSizeFormat: "png, jpeg, jpg फ़ॉर्मेट का उपयोग करें।",
  maxFileSize: "अधिकतम फ़ाइल आकार: 2 MB",
  dragPosition: "स्थिति बदलने के लिए खींचें",
  onlyNumbers: "केवल अंक",
  cannotBeRemoved: "हटाया नहीं जा सकता",
  amountInBetween: "राशि दैनिक और मासिक (शामिल) के बीच होनी चाहिए",
  amountEqualOrGreater: "राशि साप्ताहिक के बराबर या उससे अधिक होनी चाहिए",
  amountEqualOrLess: "राशि साप्ताहिक और मासिक के बराबर या उससे कम होनी चाहिए",
  cannotBeIncreased: "बढ़ाया नहीं जा सकता",
  enterPassword: "पासवर्ड दर्ज करें",
  sessionLimit: "सत्र सीमा",
  timePeriodRequired: "समय अवधि आवश्यक है",
  amountGTZero: "राशि शून्य से अधिक होनी चाहिए",
  mma: "MMA",
  counterStrike: "काउंटर स्ट्राइक",
  rugbyUnion: "रग्बी यूनियन",
  valorant: "वैलोरेंट",
  cricket: "क्रिकेट",
  dota: "DOTA-2",
  rugbyLeague: "रग्बी लीग",
  hilo: "हिलो",
  crash: "क्रैश",
  cancelBetSuccessfully: "शर्त रद्द कर दी गई",
  start: "प्रारंभ",
  invalidBetAmount: "शर्त राशि अमान्य है",
  zeroError: "0 से अधिक होना चाहिए",
  flipCoin: "सिक्का उछालें",
  customs: "कस्टम्स",
  redeemCode: "कूपन कोड रिडीम करें",
  couponText: "हम इन्हें नियमित रूप से पोस्ट करते हैं",
  copyrightText:
    "<aLink>{{website}}</aLink> का स्वामित्व और संचालन {{companyName}} द्वारा किया जाता है। पंजीकरण संख्या: {{registrationNumber}}, पंजीकृत पता: {{address}}। हमसे संपर्क करें <aMailto>{{email}}</aMailto> पर। <aLink>{{website}}</aLink> को कोमोरोस संघ के अंजुआन स्वायत्त द्वीप की सरकार द्वारा लाइसेंस प्राप्त और विनियमित किया गया है और लाइसेंस संख्या {{licenseNumber}} के तहत संचालित होता है। <aLink>{{website}}</aLink> ने सभी नियामक अनुपालनों को पार कर लिया है और किसी भी और सभी प्रकार के खेल और शर्त संचालन करने के लिए कानूनी रूप से अधिकृत है।",
  platform: "प्लेटफ़ॉर्म",
  support: "सपोर्ट",
  faq: "प्रश्नोत्तर",
  partnershipProgram: "साझेदारी कार्यक्रम",
  blog: "ब्लॉग",
  helpCenter: "सहायता केंद्र",
  aboutUs: "हमारे बारे में",
  community: "समुदाय",
  facebook: "फेसबुक",
  twitter: "ट्विटर",
  instagram: "इंस्टाग्राम",
  discord: "डिस्कॉर्ड",
  english: "अंग्रेज़ी",
  hindi: "हिन्दी",
  french: "फ़्रेंच",
  legal: "कानूनी",
  cryptoTransactions: "क्रिप्टो लेन-देन",
  sendersName: "प्रेषक का नाम",
  hideLoginHistory: "लॉगिन इतिहास छिपाएँ",
  loginMethod: "लॉगिन तरीका",
  deviceType: "डिवाइस प्रकार",
  ip: "आईपी",
  tradingDefinition:
    "क्रिप्टो ट्रेडिंग परिभाषा के अनुसार जुआ नहीं है, इसलिए यह हमारे गेमिंग लाइसेंस द्वारा आच्छादित नहीं है।",
  perks: "लाभ",
  connected: "कनेक्शन स्थापित",
  twitch: "ट्विच",
  connect: "कनेक्ट करें",
  setUpGoogleAuthenticator: "गूगल ऑथेंटिकेटर सेट करें",
  twoFACode: "2FA कोड",
  downloadTheGoogleAuthenticator:
    "1. iPhone या Android के लिए Google Authenticator ऐप डाउनलोड करें",
  saveTheFollowingAccountToken:
    "2. निम्नलिखित खाता टोकन (कुंजी) को सुरक्षित स्थान पर सहेजें",
  accountTokenKey: "खाता टोकन (कुंजी)",
  scanQRCodeWithApp: "3. Google Authenticator ऐप से QR कोड स्कैन करें",
  enterTheTokenBelow: "4. नीचे टोकन दर्ज करें",
  copied: "कॉपी किया गया",
  code: "कोड",
  furtherVerificationRequired: "अतिरिक्त सत्यापन आवश्यक",
  firstName: "पहला नाम",
  lastName: "अंतिम नाम",
  dateOfBirth: "जन्म तिथि",
  year: "वर्ष",
  addressLine: "पता पंक्ति",
  addressLineTwo: "पता पंक्ति 2",
  city: "शहर",
  province: "प्रांत",
  postalCode: "पिनकोड",
  country: "देश",
  submitInformation: "जानकारी सबमिट करें",
  level: "स्तर",
  required: "आवश्यक",
  rejected: "अस्वीकृत",
  completed: "पूर्ण",
  cancelled: "रद्द किया गया",
  onHold: "प्रतीक्षा में",
  kycRequestSubmittedSuccessfully: "KYC अनुरोध सबमिट किया गया",
  reRequested: "पुनः अनुरोध किया गया",
  cashBalance: "कैश बैलेंस",
  bonusBalance: "बोनस बैलेंस",
  specialBonus: "विशेष बोनस",
  today: "आज",
  noRewards: "कोई पुरस्कार नहीं",
  viewPendingRewards: "लंबित पुरस्कार देखें",
  totalClaimed: "कुल दावा किया गया",
  pendingRewards: "लंबित पुरस्कार",
  amount: "राशि",
  others: "अन्य",
  createdAt: "निर्माण समय",
  horseRacing: "घुड़दौड़",
  addToHomeScreen: "NextGen को होम स्क्रीन में जोड़ें",
  oneTabAccess: "अपने फोन पर 1-टैप पहुँच",
  install: "इंस्टॉल करें",
  addToHome: "होम स्क्रीन में जोड़ें",
  inChromeSafari: "Chrome/Safari में, टैप करें",
  buttonAndChoose: "बटन और चुनें",
  afterCompletingThisStep:
    "इस चरण को पूरा करने के बाद, अपने फोन पर एक टैप से NextGen Bets तक पहुँचें!",
  settlementId: "सेटलमेंट आईडी",
  commission: "कमीशन",
  totalCommission: "कुल कमीशन",
  commissionSettlement: "कमीशन सेटलमेंट",
  startplaying: "खेलना शुरू करें",
  forgotPassword: "पासवर्ड भूल गए",
  resetPassword: "पासवर्ड रीसेट करें",
  locked: "लॉक किया गया",
  unlocked: "अनलॉक किया गया",
  yourRank: "आपका रैंक",
  nextRanks: "अगले रैंक",
  allRanks: "सभी रैंक",
  bonusClaimedSuccessfully: "बोनस दावा किया गया",
  passwordUpdated: "पासवर्ड अपडेट किया गया!",
  thatsOkayItHappens:
    "कोई बात नहीं। ऐसा हो जाता है। जारी रखने के लिए नीचे बटन पर क्लिक करें। ईमेल",
  passwordsMustMatch: "पासवर्ड मेल खाने चाहिए",
  youNearlyThere: "आप लगभग पहुँच गए हैं!",
  weSendYouVerificationEmail:
    "हमने आपको एक सत्यापन ईमेल भेजा है। कृपया अपना ईमेल चेक करें और अपना खाता सत्यापित करें।",
  verifyEmailAddress: "ईमेल पता सत्यापित करें",
  pleaseNoteThatTheLinkWillExpire:
    "कृपया ध्यान दें कि यह लिंक 5 दिनों में समाप्त हो जाएगा। यदि आपने NextGen Bets में साइन अप नहीं किया है, तो कृपया इस ईमेल की अनदेखी करें। धन्यवाद",
  autoBetStops: "शर्त राशि सीमा पार होने के कारण ऑटो बेट बंद हो गई",
  casinoBets: "कैसीनो शर्तें",
  sportsBet: "खेल शर्तें",
  cryptoTrades: "क्रिप्टो ट्रेड्स",
  customBets: "कस्टम शर्तें",
  nothingFound: "कुछ नहीं मिला",
  bonus: "बोनस",
  claimedAt: "दावा किया गया",
  available: "उपलब्ध",
  previous: "पिछला",
  next: "अगला",
  tooManyRequests: "बहुत अधिक अनुरोध।",
  limitUpdatedSuccessFully: "सीमा सफलतापूर्वक अपडेट की गई",
  youLost: "आप हार गए",
  cashOutFailed: "कैश-आउट असफल",
  betAlreadyPlaced: "शर्त पहले ही लगाई गई",
  betCashedOut: "शर्त का कैश-आउट किया गया",
  noFavouritesIn: "इसमें कोई पसंदीदा नहीं है",
  team: "NextGen टीम",
  fiatAmount: "फिएट राशि",
  cryptoAmount: "क्रिप्टो राशि",
  moonpay: "मूनपे",
  paymentMethod: "भुगतान का तरीका",
  transactionId: "लेन-देन आईडी",
  address: "पता",
  comingSoon: "जल्द आ रहा है!",
  minOneCharacterRequired: "न्यूनतम एक अक्षर आवश्यक",
  verifyOtp: "OTP सत्यापित करें",
  noResults: "कोई परिणाम नहीं",
  moreFromBrand: "NextGen Bets से और देखें",
  cryptoDeposit: "क्रिप्टो जमा",
  cryptoWithdraw: "क्रिप्टो निकासी",
  fiatDeposit: "फिएट जमा",
  fiatWithdraw: "फिएट निकासी",
  goToPaymentsPage: "भुगतान पृष्ठ पर जाएँ।",
  bankTransfer: "बैंक ट्रांसफर",
  initiateTransfer: "ट्रांसफर शुरू करें",
  emt: "EMT",
  initiateEmt: "EMT शुरू करें",
  checkYourMailForFurtherDetails: "अधिक जानकारी के लिए अपना ईमेल चेक करें",
  gigadet: "Gigadet",
  wallet88: "Wallet88",
  select_language: "भाषा चुनें",
  raise_a_ticket: "टिकट उठाएँ",
  help: "मदद",
};
